import { render, staticRenderFns } from "./ClaioContentsTool.vue?vue&type=template&id=6a8de45f&scoped=true&"
import script from "./ClaioContentsTool.vue?vue&type=script&lang=ts&"
export * from "./ClaioContentsTool.vue?vue&type=script&lang=ts&"
import style0 from "./ClaioContentsTool.vue?vue&type=style&index=0&id=6a8de45f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8de45f",
  null
  
)

export default component.exports